import React from "react";
import { useReveal } from "../hooks/useReveal";

export function SectionHead({ tag, title, highlight, desc, align = "left", link }) {
  const [ref, inView] = useReveal();
  return (
    <div ref={ref} className={`reveal ${inView ? "in" : ""} ${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
      {tag && (
        <div className={`flex items-center gap-2 mb-5 ${align === "center" ? "justify-center" : ""}`}>
          <span className="w-1.5 h-1.5 bg-accent" />
          <span className="label text-[var(--muted)]">{tag}</span>
        </div>
      )}
      <h2 className="display text-[clamp(1.9rem,4.2vw,3.3rem)]">
        {title} {highlight && <span className="text-accent">{highlight}</span>}
      </h2>
      {desc && <p className="mt-5 text-[var(--muted)] text-[15px] leading-relaxed">{desc}</p>}
      {link}
    </div>
  );
}

export function Wrap({ children, id, className = "" }) {
  return (
    <section id={id} className={`max-w-[1300px] mx-auto px-5 md:px-8 py-20 md:py-28 ${className}`}>
      {children}
    </section>
  );
}

export function Note({ children }) {
  return (
    <p className="mt-8 text-[12px] text-[var(--muted)]/75 leading-relaxed max-w-4xl">{children}</p>
  );
}

// Reusable reveal wrapper: direction = up | left | right, delay index 0-5
export function Reveal({ children, direction = "up", delay = 0, className = "" }) {
  const [ref, inView] = useReveal();
  const dir = direction === "left" ? "reveal-left" : direction === "right" ? "reveal-right" : "";
  const d = delay > 0 ? `d${Math.min(delay, 5)}` : "";
  return (
    <div ref={ref} className={`reveal ${dir} ${inView ? "in" : ""} ${d} ${className}`}>
      {children}
    </div>
  );
}
